<div class="modal">
  <button class="btn-small btn-flat right modal-close"><i class="material-icons">close</i></button>
  <div class="modal-content row">
    <div class="col s12">
      <h4>Signup</h4>
    </div>
    <form class="col s12 l8 offset-l2" @submit.prevent="register" action="/any_url">
      <div class="row">
        <div class="input-field col s12">
          <input id="signup-email" ref="email" type="email"
                 v-model="email" v-bind:class="{invalid: errors.email}"/>
          <label for="signup-email">eMail Address</label>
          <span v-for="error in errors.email" class="helper-text red-text">{{error}}</span>
        </div>
      </div>
      <div class="row">
        <div class="input-field col s12 m6">
          <input id="signup-password" ref="password" type="password" autocomplete="new-password"
                 v-model="password" v-bind:class="{invalid: errors.password}"/>
          <label for="signup-password">Password</label>
          <span v-for="error in errors.password" class="helper-text red-text">{{error}}</span>
        </div>
        <div class="input-field col s12 m6">
          <input id="signup-password-confirmation" type="password" autocomplete="new-password"
                 v-model="passwordConfirmation"/>
          <label for="signup-password-confirmation">Confirmation</label>
        </div>
      </div>
      <div class="row">
        <div class="input-field col s12 m6">
          <input id="signup-display-name" ref="displayName" type="text"
                 v-model="displayName" v-bind:class="{invalid: errors.displayName}"/>
          <label for="signup-display-name">Pseudonym</label>
          <span v-for="error in errors.displayName" class="helper-text red-text">{{error}}</span>
        </div>
        <div class="input-field col s12 m6">
          <input id="signup-name" ref="name" type="text"
                 v-model="name" v-bind:class="{invalid: errors.name}"/>
          <label for="signup-name">Name</label>
          <span v-for="error in errors.name" class="helper-text red-text">{{error}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col s6 m2">
          <button class="btn waves-effect waves-light" type="submit">
            Signup <i class="material-icons right">send</i>
          </button>
        </div>
        <div class="col s6 m10">
          <span v-if="errorMessage" class="error"><i class="material-icons">warning</i> {{errorMessage}}</span>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <!--<span class="">{{ registered ? '' : '' }}</span>-->
    <a class="btn-small grey waves-effect waves-light" @click="showLogin">
      back to login
    </a>
  </div>
</div>
